module.exports = __webpack_public_path__ + "img/bg-plan-item-1.6f7bfee4.png";